module.exports = __webpack_public_path__ + "lg-0cb1b8af9950584b5cc8e8250e045508.svg";


//////////////////
// WEBPACK FOOTER
// ./~/lightgallery/dist/fonts/lg.svg
// module id = 914
// module chunks = 124